/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose one of the built-in separators - space, comma, or new line - or select Custom and type your own string, such as a pipe, a dash, or three asterisks. The separator is inserted between every pair of copies, so with 3 repetitions you get exactly 2 separators. Leave it empty for copies with no space between them at all.`)
};

const es_tr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige uno de los separadores integrados - espacio, coma o salto de línea - o selecciona Personalizado y escribe tu propia cadena, como una barra, un guión o tres asteriscos. El separador se inserta entre cada par de copias, así que con 3 repeticiones obtienes exactamente 2 separadores. Déjalo vacío para copias sin espacio entre ellas en absoluto.`)
};

const de_tr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie eines der integrierten Trennzeichen - Leerzeichen, Komma oder neue Zeile - oder wählen Sie Benutzerdefiniert und geben Sie eine eigene Zeichenfolge ein, etwa ein Pipe-Symbol, einen Bindestrich oder drei Sternchen. Das Trennzeichen wird zwischen jedem Kopienpaar eingefügt, sodass Sie bei 3 Wiederholungen genau 2 Trennzeichen erhalten. Lassen Sie es leer, damit die Kopien ganz ohne Abstand aneinander anschließen.`)
};

const nl_tr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies een van de ingebouwde scheidingstekens - spatie, komma of nieuwe regel - of selecteer Aangepast en typ je eigen string, zoals een pijp, een streepje of drie sterretjes. Het scheidingsteken wordt tussen elk paar kopieën ingevoegd, dus met 3 herhalingen krijg je precies 2 scheidingstekens. Laat het leeg voor kopieën zonder spatie ertussen.`)
};

const fr_tr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez l'un des séparateurs intégrés - espace, virgule ou nouvelle ligne - ou sélectionnez Personnalisé et tapez votre propre chaîne, comme un tuyau, un tiret ou trois astérisques. Le séparateur est inséré entre chaque paire de copies, donc avec 3 répétitions vous obtenez exactement 2 séparateurs. Laissez-le vide pour les copies sans espace entre elles du tout.`)
};

const it_tr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli uno dei separatori incorporati - spazio, virgola, o nuova riga - o seleziona Personalizzato e digita la tua stringa, come una barra verticale, un trattino, o tre asterischi. Il separatore viene inserito tra ogni coppia di copie, quindi con 3 ripetizioni ottieni esattamente 2 separatori. Lascialo vuoto per copie senza spazio tra loro affatto.`)
};

const pt_br2_tr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha um dos separadores integrados - espaço, vírgula ou nova linha - ou selecione Personalizado e digite sua própria string, como um pipe, um hífen ou três asteriscos. O separador é inserido entre cada par de cópias, então com 3 repetições você obtém exatamente 2 separadores. Deixe vazio para cópias sem espaço entre elas.`)
};

const pt_tr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha um dos separadores incorporados - espaço, vírgula ou nova linha - ou selecione Personalizado e escreva a sua própria cadeia, como um tubo, um travessão ou três asteriscos. O separador é inserido entre cada par de cópias, portanto com 3 repetições obtém exatamente 2 separadores. Deixe em branco para cópias sem espaço entre elas.`)
};

const ja_tr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`組み込みセパレーター（スペース、カンマ、改行）の1つを選択するか、「カスタム」を選択してカスタム文字列（パイプ、ダッシュ、3つのアスタリスクなど）を入力します。セパレーターは各コピーのペア間に挿入されるため、3回の繰り返しでちょうど2つのセパレーターが得られます。コピー間にスペースがないようにするには、空のままにしてください。`)
};

const zh_tr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择内置分隔符之一——空格、逗号或换行——或者选择“自定义”并输入你自己的字符串，例如竖线、破折号或三个星号。分隔符会插入到每两个副本之间，因此重复 3 次时你会得到正好 2 个分隔符。留空则副本之间完全没有间隔。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tr_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tr_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tr_faq4_a", locale)
	if (locale === "en") return en_tr_faq4_a(inputs)
	if (locale === "es") return es_tr_faq4_a(inputs)
	if (locale === "de") return de_tr_faq4_a(inputs)
	if (locale === "nl") return nl_tr_faq4_a(inputs)
	if (locale === "fr") return fr_tr_faq4_a(inputs)
	if (locale === "it") return it_tr_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_tr_faq4_a(inputs)
	if (locale === "pt") return pt_tr_faq4_a(inputs)
	if (locale === "ja") return ja_tr_faq4_a(inputs)
	return zh_tr_faq4_a(inputs)
};